export default class KeyPopup {
    static createPopup() {
        return `
    <div class="header-container">
        <h2>Awards Key</h2>
        <button class="close-btn" title="Close">
			<i class="fas fa-times" aria-hidden="true"></i>
        </button>
    </div>

	<div class="key-wrap">

		<div class="key-content">
			<a href="https://britishparking.co.uk/Safer-Parking-Scheme-/-Park-Mark" title="Park Mark" target="_blank">
				<i id="pm-icon"></i>
			</a>
	        <div class="key-text">
	            <h3>Park Mark &reg;</h3>
				<h4>Safer and More Secure Parking</h4>
	            <p>A rigorous assessment by specially trained police assessors to ensure the safety of people and vehicles through measures to deter criminal activity</p>
	        </div>
	    </div>

	    <div class="key-content">
			<a href="https://britishparking.co.uk/Park-Mark-Plus" title="Park Mark Plus" target="_blank">
				<i id="pmp-icon"></i>
			</a>
	        <div class="key-text">
	            <h3>Park Mark Plus</h3>
				<h4>Safety, Accessibility and Outstanding Customer Experience</h4>
	            <p>An elite award, achievable by the highest quality car parks which hold the Park Mark Award and in addition offer exemplary customer experience, environmental credentials, and accessibility standards</p>
	        </div>
	    </div>

		<div class="key-content">
			<a href="https://britishparking.co.uk/park-access" title="Park Access" target="_blank">
				<i id="pa-icon"></i>
			</a>
			<div class="key-text">
				<h3>Park Access &reg;</h3>
				<h4>The Standard for Accessible and Inclusive Parking</h4>
				<p>Park Access is the UKs biggest accreditation for accessible parking, auditing and certifying car parks on their accessibility and inclusivity against strict criteria</p>
			</div>
		</div>

	    <div class="key-content">
			<a href="https://britishparking.co.uk/AM-GO" title="AM-GO" target="_blank">
				<i id="am-go-icon"></i>
			</a>
			<div class="key-text">
				<h3>AM-GO</h3>
				<h4>The Standard for Airports and Off-Airport Meet and Greet Parking</h4>
				<p>The Approved Meet and Greet Parking Operator Scheme &reg; is the only police-supported scheme in the UK certifying airport meet and greet and park and ride operators on their safety and customer service</p>
			</div>
		</div>

		<div class="key-content">
			<a href="https://britishparking.co.uk/park-mark-freight" title="Park Mark Freight" target="_blank">
				<i id="pmf-icon"></i>
			</a>
			<div class="key-text">
				<h3>Park Mark Freight</h3>
				<h4>Safer and More Secure HGV Parking</h4>
				<p>A police-endorsed and assessed scheme that certifies truck stops and HGV motorway service areas on their safety, security and facilities, protecting cargo and improving driver experiences</p>
			</div>
		</div>

		<div class="key-content">
			<a href="https://britishparking.co.uk/park-access" title="Park Access EV" target="_blank">
				<i id="paev-icon"></i>
			</a>
			<div class="key-text">
				<h3>Park Access EV</h3>
				<h4>Ensuring Inclusive and Accessible EV Charging and Parking</h4>
				<p>Accredits car parks on having truly accessible parking and EV charging facilities. These car parks must also meet Park Access standards</p>
			</div>
		</div>

		<div class="key-content">
			<a href="https://www.park-active.co.uk/" title="Park Active" target="_blank">
				<i id="pact-icon"></i>
			</a>
			<div class="key-text">
				<h3>Park Active &reg;</h3>
				<h4>Healthier Journeys with Active Travel and Lower Emissions</h4>
				<p>A health and wellbeing focused scheme. Accredited facilities allow you to park and then walk or cycle for the final part of your journey, to increase health and reduce emissions</p>
			</div>
		</div>

	</div>

    <div class="bpa-logo">
		<p>The BPA is a not-for-profit membership association representing the UK's parking and mobility sector, our vision is for a diverse and inclusive membership community that supports a parking and travel experience that exceeds expectations</p>
		<a id="bpa-logo" href="https://britishparking.co.uk/" title="British Parking Association" target="_blank"></a>
	</div>
    `;
    }
}
